import V3Adapter from './v3';

export default class EntryAdapter extends V3Adapter {
  buildURL(modelName, id, snapshot, requestType) {
    const url = super.buildURL(...arguments);
    if (requestType === 'findRecord' || snapshot.adapterOptions?.['useV2Api']) {
      return url.replace('/v3/', '/v2/');
    }
    return url;
  }
}
